import React from 'react';
import styles from './OficinasInfo.module.scss';
import useScreenSize from '../../hooks/useScreenSize';

function OficinasInfo() {
  const { isMobile } = useScreenSize();

  const renderImage = () => (
    <div className={styles.imageContainer}>
      <img
        src="https://placehold.co/440x290"
        alt="Crianças participando das oficinas"
        width={500}
        height={400}
      />
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          Uma intervenção em escolas que educam grandes grupos de alunos de{' '}
          <strong>diferentes idades.</strong>
        </h2>

        {!isMobile && renderImage()}

        <div className={styles.infoList}>
          <p className={styles.infoItem}>
            Intercalamos os episódios da <strong>série audiovisual</strong> com
            atividades e aulas.
          </p>

          {isMobile && renderImage()}

          <p className={styles.infoItem}>
            Os alunos se sentem parte da história e aprendem mais e melhor.
          </p>

          <p className={styles.infoItem}>
            No final cada um faz seu próprio cérebro de massinha.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OficinasInfo;
